import { useCallback, useEffect, useState } from "react";
import { getDoc } from "firebase/firestore";
import { useShuffleAttendees } from "../useShuffleAttendees";

export const useShuffleStartTime = (eventId: string): number | null => {
  const [shuffleStartTime, setShuffleStartTime] = useState<number | null>(null);

  const { getShuffleAttendeesDoc } = useShuffleAttendees();
  const getShuffleStartTime = useCallback(async () => {
    const docRef = getShuffleAttendeesDoc(eventId);
    const docSnap = await getDoc(docRef);
    const startTime = docSnap.data()?.timestamp?.seconds;
    setShuffleStartTime(startTime);
  }, [eventId, getShuffleAttendeesDoc, setShuffleStartTime]);

  useEffect(() => {
    getShuffleStartTime();
  }, [getShuffleStartTime]);

  return shuffleStartTime;
};
